<template>
    <div>
        <md-toolbar class="md-transparent py-0 px-3" md-elevation="0">
            <div class="md-layout md-gutter">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                    </div>
                    <h4 class="title">Modification de la journée : <span class="font-medium">{{ $moment(day.date).format('DD/MM/YYYY') }}</span></h4>
                </div>
                <div class="md-layout-actions md-layout-item md-size-20 text-right align-center">
                    <div class="flex items-center justify-end header-actions">
                        <div>
                            <md-button class="md-icon-button md-raised md-warning" @click="$emit('close')">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'times']"></font-awesome-icon>
                            </md-button>
                            <md-tooltip md-direction="top">Fermer</md-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </md-toolbar>
        <form @submit.prevent="addElement">
            <div class="px-3 mt-1 pb-3">
                <p class="text-sm mb-2"><span class="font-medium">Technicien : </span> {{ technician.fullName }}</p>
                <md-divider class="mt-3 mb-2"></md-divider>
                <p class="text-sm mb-4"><span class="font-medium">Ajout d'un temps divers</span></p>
                <div class="md-layout md-gutter mt-1">
                    <div class="md-layout-item md-size-25">
                        <md-field class="md-invalid">
                            <label>Heure de début *</label>
                            <md-input type="time" v-model="start_date" />
                            <validation-error :errors="apiValidationErrors.start_date" />
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-25">
                        <md-field class="md-invalid">
                            <label>Heure de fin *</label>
                            <md-input type="time" v-model="end_date" />
                            <validation-error :errors="apiValidationErrors.end_date" />
                        </md-field>
                    </div>
                </div>
                <div class="md-invalid relative">
                    <validation-error :errors="apiValidationErrors.dates" />
                </div>
                <div class="md-layout mt-4">
                    <div class="md-layout-item md-size-100 pl-0">
                        <md-field class="md-invalid">
                            <label>Commentaire</label>
                            <md-input v-model="comment" type="text" required></md-input>
                            <validation-error :errors="apiValidationErrors.comment" />
                        </md-field>
                    </div>
                </div>
                <md-divider class="mt-3 mb-4"></md-divider>
                <div class="panel-actions">
                    <md-button class="md-success" type="submit">Valider</md-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import dateTimeFormattingMixin from "@/mixins/date-time-formatting-mixin";

export default {
    name: "PanelAddElement",
    components: {
        ValidationError
    },
    mixins: [formMixin, dateTimeFormattingMixin],
    props: {
        day: Object,
        technician: Object
    },
    data() {
        return {
            start_date: '00:00',
            end_date: '00:00',
            comment: ''
        }
    },
    methods: {
        async addElement() {
            this.resetApiValidation()
            try {
                const { data } = await this.$store.dispatch('calendar/addElement', {
                    weekNumber: this.day.weekNumber,
                    day: this.day.date,
                    technician_id: this.technician.id,
                    start_date: this.start_date ? this.$moment(this.start_date, 'HH;mm').format('HH:mm:ss') : null,
                    end_date: this.end_date ? this.$moment(this.end_date, 'HH:mm').format('HH:mm:ss') : null,
                    comment: this.comment
                })
                await this.$store.dispatch('alerts/success', 'Temps divers ajouté')
                bus.$emit('updated-panel', data)
                this.$emit('close')
            } catch (e) {
                let errors = e.response.data.errors
                if(errors[0].detail.includes('valides')) {
                    errors = [{
                        detail: errors[0].detail,
                        source: { pointer: '/data/attributes/dates' }
                    }]
                }
                this.setApiValidation(errors)
            }
        },
    }
}
</script>

<style scoped>

</style>
